<template>
    <div>
        <v-container>
            <v-row>
            <!-- HAPPINESS TIMELINE -->
                <v-col cols="12" sm="12" md="6" style="max-height: 500px; overflow-y: scroll;">
                    <v-select :disabled="client.stage == 'Onboarding'" class="pl-12" outlined :items="['Onboarding Happiness', 'Management Happiness']" v-model="happinessNotesView"></v-select>
                    <v-timeline dense v-if="happinessNotesView == 'Onboarding Happiness'">
                        <v-slide-x-transition group>
                            <v-timeline-item right v-for="(note, index) in onboardingHappiness" :key="index" class="mb-3" color="#5D327C" large fill-dot>
                                <template v-slot:icon>
                                    <v-avatar color="#252525" dark>
                                        <span style="color: #ffffff;">
                                            {{ note.authorShort }}
                                        </span>
                                    </v-avatar>
                                </template>
                                <v-card>
                                    <v-card-text cols="8" class="pt-9">
                                        {{ note.text }}
                                        <div v-if="note.positive" style="background-color: #4CAF4F; left: 0px; position: absolute; top: 0px; margin: 0px; color: #ffffff; border-radius: 4px 0px 4px 0px; padding: 2px 8px;">
                                            +{{ note.difference }}
                                        </div>
                                        <div v-else style="background-color: #F44336; left: 0px; position: absolute; top: 0px; margin: 0px; color: #ffffff; border-radius: 4px 0px 4px 0px; padding: 2px 8px;">
                                            {{ note.difference }}
                                        </div>
                                        <div style="right: 0px; position: absolute; top: 0px; margin: 0px; background-color: #5D327C; color: #ffffff; border-radius: 0px 4px 0px 4px; padding: 2px 8px;">
                                            <small>{{ note.time }}</small>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-slide-x-transition>
                    </v-timeline>
                    <v-timeline dense v-if="happinessNotesView == 'Management Happiness'">
                        <v-slide-x-transition group>
                            <v-timeline-item right v-for="(note, index) in managementHappiness" :key="index" class="mb-3" color="#5D327C" large fill-dot>
                                <template v-slot:icon>
                                    <v-avatar color="#252525" dark>
                                        <span style="color: #ffffff;">
                                            {{ note.authorShort }}
                                        </span>
                                    </v-avatar>
                                </template>
                                <v-card>
                                    <v-card-text cols="8" class="pt-9">
                                        {{ note.text }}
                                         <div v-if="note.positive" style="background-color: #4CAF4F; left: 0px; position: absolute; top: 0px; margin: 0px; color: #ffffff; border-radius: 4px 0px 4px 0px; padding: 2px 8px;">
                                            +{{ note.difference }}
                                        </div>
                                        <div v-else style="background-color: #F44336; left: 0px; position: absolute; top: 0px; margin: 0px; color: #ffffff; border-radius: 4px 0px 4px 0px; padding: 2px 8px;">
                                            {{ note.difference }}
                                        </div>
                                        <div style="right: 0px; position: absolute; top: 0px; margin: 0px; background-color: #5D327C; color: #ffffff; border-radius: 0px 4px 0px 4px; padding: 2px 8px;">
                                            <small>{{ note.time }}</small>
                                        </div>
                                        <div style="right: 0px; position: absolute; top: 0px; margin: 0px; background-color: #5D327C; color: #ffffff; border-radius: 0px 4px 0px 4px; padding: 2px 8px;">
                                            <small>{{ note.time }}</small>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-slide-x-transition>
                    </v-timeline>
                </v-col>
            <!-- NOTES TIMELINE -->
                <v-col cols="12" sm="12" md="6" style="max-height: 500px; overflow-y: scroll;">
                    <v-select :disabled="client.stage == 'Onboarding'" class="pl-12" outlined :items="['Onboarding Notes', 'Management Notes']" v-model="notesView"></v-select>
                    <v-timeline dense v-if="notesView == 'Management Notes'">
                        <v-slide-x-transition group>
                            <v-timeline-item right v-for="(note, index) in managementNotes" :key="index" class="mb-3" color="#5D327C" large fill-dot>
                                <template v-slot:icon>
                                    <v-avatar color="#252525" dark>
                                        <span style="color: #ffffff;">
                                            {{ note.authorShort }}
                                        </span>
                                    </v-avatar>
                                </template>
                                <v-card>
                                    <v-card-text cols="8" class="pt-9">
                                        {{ note.text }}
                                        <div style="right: 0px; position: absolute; top: 0px; margin: 0px; background-color: #5D327C; color: #ffffff; border-radius: 0px 4px 0px 4px; padding: 2px 8px;">
                                            <small>{{ note.time }}</small>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-slide-x-transition>
                    </v-timeline>
                    <v-timeline dense v-else>
                        <v-slide-x-transition group>
                            <v-timeline-item right v-for="(note, index) in onboardingNotes" :key="index" class="mb-3" color="#5D327C" large fill-dot>
                                <template v-slot:icon>
                                    <v-avatar color="#252525" dark>
                                        <span style="color: #ffffff;">
                                            {{ note.authorShort }}
                                        </span>
                                    </v-avatar>
                                </template>
                                <v-card>
                                    <v-card-text cols="8" class="pt-9">
                                        {{ note.text }}
                                        <div style="right: 0px; position: absolute; top: 0px; margin: 0px; background-color: #5D327C; color: #ffffff; border-radius: 0px 4px 0px 4px; padding: 2px 8px;">
                                            <small>{{ note.time }}</small>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-timeline-item>
                        </v-slide-x-transition>
                    </v-timeline>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import moment from 'moment'
    export default {
        data(){
            return {
                id: this.$route.params.id,
                adminUser: this.$store.getters.currentAdminUser,
                client: {},
                notesView: 'Onboarding Notes',
                happinessNotesView: 'Onboarding Happiness',
                onboardingNotes: [],
                managementNotes: [],
                onboardingHappiness: [],
                managementHappiness: []
            }
        },
        computed: {
            progress () {
                return this.completedManagementTasks / this.totalManagementTasks * 100
            }
        },
        methods: {
            getStuff(){
                firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                    this.client = docSnapshot.data()
                    if(this.client.stage == 'Onboarding'){
                        this.notesView = 'Onboarding Notes'
                        this.happinessNotesView = 'Onboarding Happiness'
                    }else{
                        this.notesView = 'Management Notes'
                        this.happinessNotesView = 'Management Happiness'
                    }
                }, err => { console.log(`Encountered error: ${err}`) })
                this.loadManagementNotes()
                this.loadOnboardingNotes()
                this.loadManagementHappiness()
                this.loadOnboardingHappiness()
            },
            loadOnboardingNotes(){
                firebase.firestore().collection('clients').doc(this.id).collection('onboarding-notes').onSnapshot(snapshot => {
                    this.onboardingNotes = []
                    snapshot.forEach(doc => {
                        let note = doc.data()
                        note.time = moment(Number(note.time)).format('llll')
                        this.onboardingNotes.unshift(note)
                    })
                })
            },
            loadManagementNotes(){
                firebase.firestore().collection('clients').doc(this.id).collection('management-notes').onSnapshot(snapshot => {
                    this.managementNotes = []
                    snapshot.forEach(doc => {
                        let note = doc.data()
                        note.time = moment(Number(note.time)).format('llll')
                        this.managementNotes.unshift(note)
                    })
                })
            },
            loadOnboardingHappiness(){
                firebase.firestore().collection('clients').doc(this.id).collection('onboarding-happiness-notes').onSnapshot(snapshot => {
                    this.onboardingHappiness = []
                    snapshot.forEach(doc => {
                        let note = doc.data()
                        note.time = moment(Number(note.time)).format('llll')
                        note.difference = note.newHappiness - note.oldHappiness
                        if(note.difference >= 0){
                            note.positive = true
                        }else{
                            note.positive = false
                        }
                        this.onboardingHappiness.unshift(note)
                    })
                })
            },
            loadManagementHappiness(){
                firebase.firestore().collection('clients').doc(this.id).collection('management-happiness-notes').onSnapshot(snapshot => {
                    this.managementHappiness = []
                    snapshot.forEach(doc => {
                        let note = doc.data()
                        note.time = moment(Number(note.time)).format('llll')
                        note.difference = note.newHappiness - note.oldHappiness
                        if(note.difference >= 0){
                            note.positive = true
                        }else{
                            note.positive = false
                        }
                        this.managementHappiness.unshift(note)
                    })
                })
            }
        },
        mounted(){
            this.getStuff()
        }
    }
</script>
<style>
.date{
    width: 100px;
    position: absolute;
    right: 0;
}
.commentsList{
    max-height: 500px;
    overflow: scroll;
}
</style>